import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BlockFilterDTO } from "src/app/shared/models/block-filter-dto";
import { environment } from "src/environments/environment";

import { BlockDTO, BlockSimplifiedDTO } from "../../shared/models/block-dto";
import { PageManager } from "@shared/models/page-manager";
import { Pagination } from "@shared/models/pagination";

@Injectable({
  providedIn: "root"
})
export class BlockService {
  private blockUrl = "blocks/";
  private blockV2Url = "v2/blocks";

  constructor(private http: HttpClient) {}

  save(blockDTO: BlockDTO): Observable<any> {
    return this.http.post<any>(environment.apiUrl + this.blockUrl, blockDTO);
  }

  listAll(): Observable<BlockSimplifiedDTO[]> {
    return this.http.get<BlockSimplifiedDTO[]>(
      environment.apiUrl + this.blockV2Url + "/allSimplified"
    );
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(environment.apiUrl + `${this.blockUrl}${id}`);
  }

  findById(id: number): Observable<BlockDTO> {
    return this.http.get<BlockDTO>(
      environment.apiUrl + `${this.blockUrl}${id}`
    );
  }

  findByFilters(
    blockFilterDTO: BlockFilterDTO,
    pageManager: PageManager,
    sort: string
  ): Observable<Pagination<BlockDTO[]>> {
    let query = "";
    if (blockFilterDTO.clientId) {
      query += `&clientId=${blockFilterDTO.clientId}`;
    }
    if (blockFilterDTO.blockCode) {
      query += `&blockCode=${blockFilterDTO.blockCode}`;
    }
    if (blockFilterDTO.administratorFleetId) {
      query += `&administratorFleetId=${blockFilterDTO.administratorFleetId}`;
    }
    return this.http.get<Pagination<BlockDTO[]>>(
      environment.apiUrl +
        `${this.blockV2Url}?page=${pageManager.pageIndex}&size=${pageManager.pageSize}${query}${sort}`
    );
  }

  edit(id: number, blockDTO: BlockDTO): Observable<any> {
    return this.http.put<any>(
      environment.apiUrl + `${this.blockUrl}${id}`,
      blockDTO
    );
  }

  autocompleteServiceBlock(
    tag: string,
    clientId?: number
  ): Observable<BlockSimplifiedDTO[]> {
    let query = "?";
    if (tag) {
      query += `&tag=${tag}`;
    }
    if (clientId) {
      query += `&clientId=${clientId}`;
    }
    return this.http.get<BlockSimplifiedDTO[]>(
      environment.apiUrl + `${this.blockV2Url}/allSimplified${query}`
    );
  }
}
